import React from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

import { PaymentPage } from './PaymentPage';
import { PaymentPageStepProps } from './paymentStep.types';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_API_KEY!);

export const PaymentStep = (props: PaymentPageStepProps) => {
  const { isActive } = props;

  return <Elements stripe={stripePromise}>{isActive ? <PaymentPage {...props} /> : null}</Elements>;
};
